import { isPlainObject } from "lodash-es";

export const isRichterFrenzelSapIntegration = (settings: unknown): boolean => {
  if (!settings || !isPlainObject(settings)) return false;

  const integrationSettings = settings as Record<string, unknown>;
  return integrationSettings.sapPartnerId === "richter-frenzel";
};
